const SuspenseFallback = () => {
    return (
        <div id="page_root_loader">
            <span className="loader"></span>
        </div>
    );
};
export default SuspenseFallback;